var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiagonalTop = function SvgDiagonalTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diagonal-top_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1600 337H0L1600 0v337Z",
    fill: "#F3FFCE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006E61",
    strokeWidth: 3,
    d: "m-.309 335.532 1599.999-337"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 253,
    r: 10,
    fill: "#006E61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177,
    cy: 87,
    r: 10,
    fill: "#006E61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diagonal-top_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1600v337H0z"
  })))));
};

export { SvgDiagonalTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYwMCAzMzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBkPSJNMTYwMCAzMzdIMEwxNjAwIDB2MzM3WiIgZmlsbD0iI0YzRkZDRSIvPjxwYXRoIHN0cm9rZT0iIzAwNkU2MSIgc3Ryb2tlLXdpZHRoPSIzIiBkPSJtLS4zMDkgMzM1LjUzMiAxNTk5Ljk5OS0zMzciLz48Y2lyY2xlIGN4PSIzODgiIGN5PSIyNTMiIHI9IjEwIiBmaWxsPSIjMDA2RTYxIi8+PGNpcmNsZSBjeD0iMTE3NyIgY3k9Ijg3IiByPSIxMCIgZmlsbD0iIzAwNkU2MSIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTYwMHYzMzdIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";